export function stickyKeyInfo(){
  const element = document.getElementById("event-key-info");
  const fixedMenu = document.querySelector('.site-header-section__top');

  let initialTranslate = 0;
  let transitionDistance = 0;
  let imageHeight = 0;


  function updateImageConstants() {
    const imageElement = document.querySelector('.site-page__events-left-image');
    if (imageElement) {
      imageHeight = imageElement.offsetHeight;
      initialTranslate = -imageHeight - 140;
      transitionDistance = imageHeight + 140;
    } else {

      initialTranslate = -620;
      transitionDistance = 620;
    }
  }
  
  let fixedMenuHeight, extraOffset, startScroll;
  
  function recalcDimensions() {
    updateImageConstants(); 
    fixedMenuHeight = fixedMenu ? fixedMenu.offsetHeight : 0;
    extraOffset = fixedMenuHeight + 24; 
    startScroll = Math.max(0, element.offsetTop + initialTranslate - extraOffset);
  }
  
  function handleScroll() {
    if (window.innerWidth <= 1280) {
      element.style.transform = '';
      return;
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let delta = scrollTop - startScroll;
    delta = Math.max(0, Math.min(delta, transitionDistance));
    const newTranslate = initialTranslate + delta;
    element.style.transform = `translateY(${newTranslate}px)`;
  }
  
  recalcDimensions();
  handleScroll();
  
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", function() {
    recalcDimensions();
    handleScroll();
  });
}
